import '../assets/lib/lib.scss'
import BasicSelect from './BasicSelect.vue'
import ListSelect from './ListSelect.vue'
import MultiListSelect from './MultiListSelect.vue'
import MultiSelect from './MultiSelect.vue'
import ModelSelect from './ModelSelect.vue'
import ModelListSelect from './ModelListSelect.vue'

export {
  BasicSelect,
  MultiSelect,
  ListSelect,
  MultiListSelect,
  ModelSelect,
  ModelListSelect
}
